import React from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

export const LoadingSpinner = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100vw"
      height="100vh"
      bg="white"
    >
      <Spinner size="xl" thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" />
    </Flex>
  );
};